/************************************************************
 * Primitive Definitions
 */
const __LINE_HEIGHT__ = {
  lh16: '1rem',
  lh20: '1.25rem',
  lh24: '1.5rem',
  lh28: '1.75rem',
  lh32: '2rem',
  lh36: '2.25rem',
  lh42: '2.625rem',
} as const

/************************************************************
 * Semantic Definitions
 */
const __SEMANTIC_LINE_HEIGHT__ = {
  xxs: __LINE_HEIGHT__.lh16,
  xs: __LINE_HEIGHT__.lh20,
  sm: __LINE_HEIGHT__.lh24,
  md: __LINE_HEIGHT__.lh28,
  lg: __LINE_HEIGHT__.lh32,
  xl: __LINE_HEIGHT__.lh36,
  xxl: __LINE_HEIGHT__.lh42,
} as const

/************************************************************
 * Export
 */
export const LINE_HEIGHT = Object.freeze({
  ...__LINE_HEIGHT__,
  ...__SEMANTIC_LINE_HEIGHT__,
})
